function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import SmileyRatingSystem from "./smiley-rating-system/SmileyRatingSystem";
import StarRatingSystem from "./star-rating-system/StarRatingSystem";
import StarModerniseRatingSystem from "@limitless/modern/components/star-ratings/StarRatings";
export const SMILEY_RATING_SYSTEM = "3-faces";
export const STAR_RATING_SYSTEM = "5-stars";
export const SEVEN_SMILEY_RATING_SYSTEM = "7-faces";
const RatingSystem = ({
  message,
  useDefaultScore,
  isexpertScore,
  ...rest
}) => {
  const {
    name,
    maxScore,
    defaultScore
  } = message.custScoreScheme;
  let rating = message.customerScore || -1;
  let hasPreviousScore = false;
  const RATING_SYSTEM_COMPONENTS = React.useMemo(() => {
    return {
      [STAR_RATING_SYSTEM]: rest.moderniseStar ? StarModerniseRatingSystem : StarRatingSystem,
      [SMILEY_RATING_SYSTEM]: SmileyRatingSystem,
      [SEVEN_SMILEY_RATING_SYSTEM]: SmileyRatingSystem
    };
  }, [rest.moderniseStar]);
  if (useDefaultScore && defaultScore && !message.customerScore) {
    rating = defaultScore;
    hasPreviousScore = true;
  }
  if (message.customerScore) {
    hasPreviousScore = true;
  }
  let schemeMaxScore = maxScore;

  //on mount tell the parent there was a default score
  React.useEffect(() => {
    if (rating !== -1 && !rest.disabled && rating !== 0) {
      rest.onClick(rating);
    }
  }, []);
  let ScoreScheme = RATING_SYSTEM_COMPONENTS[name];
  //default smiley in case we get sent a string
  ScoreScheme = ScoreScheme || RATING_SYSTEM_COMPONENTS[SMILEY_RATING_SYSTEM];
  if (isexpertScore) {
    var _message$custClientRe, _message$custClientRe2;
    rating = (_message$custClientRe = (_message$custClientRe2 = message.custClientReview) === null || _message$custClientRe2 === void 0 ? void 0 : _message$custClientRe2.expertScore) !== null && _message$custClientRe !== void 0 ? _message$custClientRe : 0;
    ScoreScheme = RATING_SYSTEM_COMPONENTS[STAR_RATING_SYSTEM];
    schemeMaxScore = 5;
  }
  return /*#__PURE__*/React.createElement(ScoreScheme, _extends({
    rating: rating,
    maxScore: schemeMaxScore,
    schemeName: name,
    hasPreviousScore: hasPreviousScore
  }, rest));
};
export default RatingSystem;
RatingSystem.propTypes = {
  message: PropTypes.object.isRequired,
  useDefaultScore: PropTypes.bool,
  isexpertScore: PropTypes.bool
};
RatingSystem.defaultProps = {
  useDefaultScore: true
};